import React from 'react';

import {Button, LoadingSpinner} from '@albert-io/atomic';
import {useStudentDashboard} from '../StudentDashboard/StudentDashboard.store';

export default function JoinClassroomSubmitButton({className}: PropsWithClassNameOptional) {
  const isError = useStudentDashboard((state) => state.isStudentEnrollmentError);
  const isRequestPending = useStudentDashboard((state) => state.isStudentEnrollmentPending);
  const value = useStudentDashboard((state) => state.classroomCode);

  return (
    <Button
      aria-label='Submit code'
      className={className}
      data-testid='join-code-form__submit'
      disabled={isRequestPending || isError || value === ''}
      type='submit'
    >
      {isRequestPending ? <LoadingSpinner bottomMarginLevel={0} className='px-x3' /> : 'Join Class'}
    </Button>
  );
}
